import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { connectHierarchicalMenu } from 'react-instantsearch-dom';

import Typography from '../../atoms/typography';
import { Heading } from './left-rail-shared';

const CategoryDetail = styled.details(() => ({
  outline: 0,
  ol: { marginLeft: '2rem' },
  summary: {
    outline: 'none',
    lineHeight: '3rem',
    '::-webkit-details-marker, ::before': {
      display: 'none !important'
    }
  }
}));

const CategorySummary = styled(Typography)(({ active, theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  lineHeight: '3rem',
  textDecoration: 'none',
  transition: `${theme.animation.default} ${theme.animation.ease}`,
  span: { marginLeft: 'auto' },
  a: {
    color: active ? theme.color.brand : theme.color.brandLight,
    display: 'flex',
    textDecoration: 'none',
    width: '100%'
  },
  ':hover': {
    a: {
      color: theme.color.brand
    }
  }
}));

const HierarchicalMenu = ({
  items,
  refine,
  createURL
}) => {
  const onCategoryClick = (e, item) => {
    e.preventDefault();
    refine(item.value);
  };

  return (
    <ol>
      {
        items.map((item) => (
          <li key={item.label}>
            <CategoryDetail open={item.isRefined}>
              <CategorySummary
                element="summary"
                like="dec-1"
                active={item.isRefined}
                onClick={(event) => onCategoryClick(event, item)}
              >
                <a href={createURL(item.value)}>
                  {item.label}
                  <span>{`(${item.count})`}</span>
                </a>
              </CategorySummary>
              {item.items && (
              <HierarchicalMenu
                items={item.items ?? []}
                refine={refine}
                createURL={createURL}
              />
              )}
            </CategoryDetail>
          </li>
        ))
      }
    </ol>
  );
};

HierarchicalMenu.propTypes = {
  createURL: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  refine: PropTypes.func.isRequired
};

const CategoryWrapper = styled.section``;

const Menu = styled(HierarchicalMenu)(() => ({ marginTop: '1rem ' }));

const Categories = ({
  createURL,
  items,
  refine,
  ...props
}) => (
  <CategoryWrapper {...props}>
    <Heading role="heading" aria-level="2" element="label" like="label-1">
      Categories
    </Heading>

    <Menu
      createURL={createURL}
      items={items}
      refine={refine}
    />
  </CategoryWrapper>
);

Categories.propTypes = {
  createURL: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  refine: PropTypes.func.isRequired
};

export default connectHierarchicalMenu(Categories);

export const attributes = [
  'categories.lvl0',
  'categories.lvl1',
  'categories.lvl2'
];
